require('../../lib/ngStorage/ngStorage.min.js');
require('../common/jv.Facebook.js');
require('../common/jv.TemplateLoader');
require('../common/jv.Modal');
require('../common/jv.MessageBar');
require('../common/jv.Resize');
require('../common/jv.ga.service');
require('../common/directives/jv.Common.Directives.Focus');
require('./jv.login.controller.js');
require('./jv.reset.password.controller.js');

const app = angular.module('jv.login.app', [
    'ngRoute',
    'jv.FacebookService',
    'jv.Common.TemplateLoader',
    'jv.Common.Modal',
    'jv.Common.MessageBar',
    'jv.Common.Resize',
    'jv.common.ga.service.js',
    'jv.Common.Directives.Focus',
    'jv.login.controller',
    'jv.reset.password.controller'
])
.value('modalTemplateUrl', '../login/htm/common/modal.html')
.value('messageBarTemplateUrl', '../login/htm/common/messageBar.html');

window.app = app;